<template>
  <div>
    <main-header-nav :content="'造价模板列表'"></main-header-nav>
    <div v-loading="loading">
      <div style="width: 90%;min-width: 1024px;margin: 0px auto;">
        <el-button
          type="primary"
          v-on:click="onCreateProjectTemplate"
          style="width: 120px;"
          >新建造价模板</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 90%;min-width: 1024px;margin: 10px auto;"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="100"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick('edit', scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button @click="handleClick('copy', scope.row)" type="text" size="small"
              >复制</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0px 10px 0px;">
        <el-pagination
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="totalSize"
          style="text-align: center;"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'ProjectTemplates',

  components: {
    MainHeaderNav
  },

  methods: {
    handleClick (type, row) {
      var self = this
      if (type === 'edit') {
        this.$router.push(`/edit_project_template/${row.id}`)
      } else if (type === 'copy') {
        this.$confirm('即将复制' + row.name + '模板', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          var template = this.Utils.deepClone(row)
          template.name += '副本'
          template.id = 0
          this.postRequest('/project_templates/add', template)
            .then(resp => {
              if (resp && resp.code === 200) {
                self.requestPage(1)
              }
            })
        })
      }
    },

    changePage (page) {
      this.$data.curPage = page
      this.requestPage(page)
    },

    requestPage (page) {
      var self = this
      this.$data.loading = true
      this.getRequest('/project_template/' + this.pageSize + '/' + page)
        .then(resp => {
          if (resp && resp.result) {
            self.$data.loading = false
            var projectTemplates = resp.result.content
            self.$data.tableData = projectTemplates
            self.$data.totalSize = resp.result.totalElements
          }
        })
    },

    onCreateProjectTemplate () {
      this.$router.push('/add_project_template')
    }
  },

  data () {
    return {
      loading: false,
      tableData: [],
      totalSize: 0,
      curPage: 1,
      pageSize: 10
    }
  },

  mounted () {
    this.requestPage(this.$data.curPage)
  }
}
</script>

<style scoped></style>
